<template>
  <div>
    <div class="set-groups-wrap" v-if="showComponentName && !popoverOpening">
      <span
        class="set-groups"
        @mousedown.stop
        @mouseenter.stop="mouseenterHandle($event)"
        @mouseleave.stop="mouseleaveHandle($event)"
        @click.stop="openLayoutComponentEdit"
      >
        <i class="icon" :class="handle.iconClass" v-if="handle.iconClass"></i>
        <span>{{ handle.name }}</span>
      </span>
    </div>
    <div class="set-groups-wrap" v-if="((isActive && showSet) || isClone || isDrawer || isCanDel) && !popoverOpening">
      <!-- 图片组件的图片设置 -->
      <span
        v-if="showImageSet"
        class="set-groups set relative"
        @mousedown.stop
        @click.stop="openSet('showImageSelector')"
      >
        <span class="icon icon-portal-bg-back"></span>
        <resourceLib :visible.sync="showImageSelector" :imgSrc.sync="imgVal" :iconColor.sync="iconColorVal" />
      </span>
      <!-- 背景图设置 -->
      <span v-if="showBgImageSet" class="set-groups set relative" @mousedown.stop @click.stop="openImgLib">
        <span class="icon icon-portal-bg-back"></span>
      </span>
      <!-- 文本大小快捷设置 -->
      <span
        v-if="showFontSizeSet"
        class="set-groups set relative"
        @mousedown.stop
        @click.stop="openSet('showFontSizeSelector')"
      >
        <span class="fs14">{{ fontSize }}</span>
        <span
          class="icon icon-portal-arrows-down"
          :class="showFontSizeSelector ? 'rotate' : ''"
          style="color: #919191"
        ></span>
        <quick-font-size v-if="showFontSizeSelector" :value.sync="fontSize" :visible.sync="showFontSizeSelector" />
      </span>
      <!-- 文本颜色快捷设置-->
      <span
        v-if="showFontColorSet"
        class="set-groups set"
        style="position: relative"
        @mousedown.stop
        @click.stop="openSet('showFontColorSelector')"
      >
        <span class="icon icon-portal-A bottom-color-wrap"
          ><span class="bottom-color" :style="getFontColor"></span
        ></span>
        <span
          class="icon icon-portal-arrows-down"
          :class="showFontColorSelector ? 'rotate' : ''"
          style="color: #919191"
        ></span>
        <fontColorSelector
          v-if="showFontColorSelector"
          :color.sync="color"
          :isThemeColor.sync="isThemeColor"
          :visible.sync="showFontColorSelector"
        />
      </span>
      <!-- 图标设置 -->
      <span
        v-if="showIconSet"
        class="set-groups set relative"
        @mousedown.stop
        @click.stop="openSet('showIconSelector')"
        style="padding: 0 8px"
      >
        <span class="icon icon-portal-menu_icon"></span>
        <!--        <span class="icon icon-portal-arrows-down" :class="showIconSelector ? 'rotate' : ''" style="color: #919191;"></span>-->
        <resourceLib
          :visible.sync="showIconSelector"
          :imgSrc.sync="iconSrc"
          :iconType.sync="iconType"
          :iconColor.sync="iconColorVal"
          :resInfo.sync="resInfo"
          defaultType="icon"
        />
      </span>
      <!-- 背景快捷设置-->
      <span
        v-if="showBgColorSet"
        class="set-groups set relative"
        @mousedown.stop
        @click.stop="openSet('showBgColorSelector')"
      >
        <span class="icon icon-portal-color-paint bottom-color-wrap"
          ><span class="bottom-color" :style="getBgColor"></span
        ></span>
        <span
          class="icon icon-portal-arrows-down"
          :class="showBgColorSelector ? 'rotate' : ''"
          style="color: #919191"
        ></span>
        <color-selector v-if="showBgColorSelector" :background.sync="background" :visible.sync="showBgColorSelector" />
      </span>
      <span v-if="showLine" class="line"></span>
      <span class="set-groups set" @mousedown.stop @click.stop="handleShowRightToolbar" v-if="isActive && showSet">
        <span class="icon icon-portal-setting1"></span>
      </span>
      <span class="set-groups" v-if="isClone" @mousedown.stop @click.stop="clone">
        <span class="icon icon-portal-clone"></span>
      </span>
      <!-- 抽屉、弹出框打开按钮 -->
      <span class="set-groups" v-if="isDrawer || isPopover" @mousedown.stop @click.stop="openBox">
        <span class="icon-portal-preview-open1"></span>
      </span>
      <!-- 只有删除按钮 一直显示 -->
      <span class="set-groups delete" v-if="isCanDel" @mousedown.stop @click.stop="del">
        <span class="icon icon-portal-delete"></span>
      </span>
    </div>
  </div>
</template>

<script>
import resourceLib from "../../../modules/components/resourceLib"
import { findCurrentComponentPathInLayoutByRectId } from "../../../utils/index"
import $ from "jquery"
export default {
  name: "rectHandleBtns",
  components: { resourceLib },
  props: {
    handleList: {
      type: Array
    },
    ids: {
      type: Object
    },
    handle: {
      type: Object
    },
    isCanDel: {
      type: Boolean
    },
    isClone: {
      type: Boolean
    },
    isDrawer: {
      type: Boolean
    },
    isPopover: {
      type: Boolean
    },
    options: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      isShowAllBtns: false,
      showFontColorSelector: false,
      showFontSizeSelector: false,
      showBgColorSelector: false,
      showBgImageSelector: false,
      showImageSelector: false,
      showIconSelector: false,
      fontSizeInputBlur: false,
      typeArr: [
        "showFontColorSelector",
        "showFontSizeSelector",
        "showBgColorSelector",
        "showBgImageSelector",
        "showIconSelector",
        "showImageSelector"
      ]
    }
  },
  watch: {
    activeId: {
      handler(n, o) {
        this.typeArr.forEach(item => {
          this[item] = false
        })
      },
      deep: true
    }
  },
  methods: {
    openSet(type) {
      this.handleShowRightToolbar()
      if (type === "showImageSelector" || type === "showIconSelector") {
        sessionStorage.setItem("openResourceLib", true)
      }
      this.fontSizeInputBlur = false
      this.typeArr.forEach(item => {
        if (item === type) {
          this[type] = !this[type]
        } else {
          this[item] = false
        }
      })
    },
    mouseenterHandle(e) {
      this.$emit("mouseenterHandle", e)
    },
    mouseleaveHandle(e) {
      this.$emit("mouseleaveHandle", e)
    },
    // 激活选中组件
    openLayoutComponentEdit() {
      //  只有在第一层的时候，才执行点击操作
      this.$emit("openLayoutComponentEdit")
      // 改成点击出现父级工具栏
      $($(this.$el)).siblings(".handle-btn-items").toggleClass("displayBlock")
    },
    //删除事件触发
    del() {
      this.$emit("del")
    },
    //克隆事件触发
    clone() {
      this.$emit("clone")
    },
    handleShowRightToolbar() {
      this.$store.commit("states/changeShowRightToolbarStatus", true)
      this.$emit("openLayoutComponentEdit")
    },
    //打开抽屉、弹出框
    openBox() {
      this.$emit("openBox")
    },
    openImgLib() {
      this.handleShowRightToolbar()
      // 模拟点击
      let bg = this.options.background
      let index = bg.findIndex(item => item.type === "img")
      let defaultImage = document.getElementsByClassName("toolbar")[0].getElementsByClassName("default-image") // 没有图片时生成默认值
      if (index === -1 && defaultImage.length > 0) {
        defaultImage[0].click()
      }
      let openLib = document.getElementsByClassName("toolbar")[0].getElementsByClassName("open_lib_btn") // 打开资源库按钮
      if (openLib.length > 0) {
        openLib[0].click()
        sessionStorage.setItem("openResourceLib", true)
      }
    }
  },
  computed: {
    getFontColor() {
      let color = this.color?.color ? this.color.color : this.color.data ? this.color.data.stops[0][0] : this.color
      return {
        background: color
      }
    },
    getBgColor() {
      let bgColorSet = this.background?.find(item => item.type === "color")
      let bgColor = (bgColorSet && bgColorSet.color) || "rgba(255,255,255,0)"
      return {
        background: bgColor
      }
    },
    activeId() {
      return this.$store.state.states.activeID
    },
    showFontSizeSet() {
      const shapeArr = ["cxText", "cxButton", "cxLabel"]
      return shapeArr.indexOf(this.handle.shape) > -1 && this.handle.name !== "回到顶部按钮" && this.handle.name !== "弹出框按钮"
    },
    showFontColorSet() {
      const shapeArr = ["cxText", "cxButton"]
      return shapeArr.indexOf(this.handle.shape) > -1 && this.handle.name !== "回到顶部按钮" && this.handle.name !== "弹出框按钮"
    },
    showBgColorSet() {
      const shapeArr = ["cxButton", "layoutComponent", "emptyLayoutComponent"]
      return shapeArr.indexOf(this.handle.shape) > -1 && this.handle.name !== "回到顶部按钮" && this.handle.name !== "弹出框按钮"
    },
    showImageSet() {
      if (this.options?.filedMapping) {
        // 接了外接数据源，所以不能随便切换图片
        return false
      }
      const shapeArr = ["imageComponent"]
      return shapeArr.indexOf(this.handle.shape) > -1 ? true : false
    },
    showBgImageSet() {
      const shapeArr = ["layoutComponent", "emptyLayoutComponent"]
      return shapeArr.indexOf(this.handle.shape) > -1 ? true : false
    },
    showIconSet() {
      const shapeArr = ["cxButton"]
      return shapeArr.indexOf(this.handle.shape) > -1 && this.handle.name !== "回到顶部按钮" && this.handle.name !== "弹出框按钮"
    },
    showLine() {
      return (
        this.showFontSizeSet ||
        this.showFontColorSet ||
        this.showBgColorSet ||
        this.showImageSet ||
        this.showBgImageSet ||
        this.showIconSet
      )
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    color: {
      get() {
        if (this.options.colorArr && JSON.stringify(this.options.colorArr) !== "{}") {
          return this.options.colorArr
        }
        return this.options.color
      },
      set(newVal) {
        if (this.options.colorArr && JSON.stringify(this.options.colorArr) !== "{}") {
          this.$changeOptionsEV(newVal, "colorArr", false)
        } else {
          this.$changeOptionsEV(newVal, "color", false)
        }
      }
    },
    isThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    background: {
      get() {
        return this.options.background
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    imgVal: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    iconColorVal: {
      get() {
        return this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    isActive() {
      let active =
        !Object.keys(this.ids).some(k => this.ids[k] !== this.handle?.ids[k]) &&
        !Object.keys(this.handle?.ids).some(k => this.ids[k] !== this.handle?.ids[k])
      return active
    },
    showSet() {
      let showRightToolbar = this.$store.state.states.showRightToolbar
      return !showRightToolbar || (showRightToolbar && !this.isElementInComplex)
    },
    isElementInComplex() {
      if (this.ids.uid) {
        return true
      }
      if (this.ids.directionIndex !== null && typeof this.ids.directionIndex !== "undefined") {
        return true
      }
      if (this.ids.elementInLayoutId !== null && typeof this.ids.elementInLayoutId !== "undefined") {
        return true
      }
      if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
        return true
      }
      let isInHeader = false
      let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList || []
      const path = findCurrentComponentPathInLayoutByRectId(pageLayoutList, this.ids.rect_id)
      if (path) {
        let pageLayout = this.getAttrById(
          this.$store.state[this.request_prefix],
          {
            container_id: this.ids.container_id,
            pageLayoutId: path[0]
          },
          "pageLayout"
        )
        isInHeader = pageLayout?.options?.inDocument === "header" || pageLayout?.options?.inDocument === "footer"
      }
      if (isInHeader) return true
      return false
    },
    showComponentName() {
      return this.$store.state.states.showComponentName
    },
    popoverOpening() {
      if (!this.options?.popoverPath) {
        return false
      } else {
        const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList || []
        const opening = pageLayoutList.find(
          item =>
            item.options.inDocument === "popover" &&
            item.options.source_id === this.options.popoverPath &&
            this.options.openPopover
        )
        return opening
      }
    }
  }
}
</script>

<style scoped>
.icon-portal-preview-open1:before {
  color: rgba(0, 0, 0, 0.8);
}
.line {
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 1px;
  background-color: var(--topOperationBorderColor);
  margin: 0 2px;
}
.relative {
  position: relative;
}
.new-btn-groups .set-groups .fs14 {
  font-size: 14px;
}
</style>
